import { useMemo } from 'react'
import Head from 'next/head'
import { useTranslations } from 'next-intl'

const BaseHead = ({
  title,
  slug = '',
  localeFile = 'common',
  description = 'metaDescription',
  isDefault = true,
}) => {
  const t = useTranslations(localeFile)
  const tCommon = useTranslations('common')
  const descriptionTranslate = isDefault ? tCommon(description) : t(description)

  const titleName = useMemo(() => {
    return title
      ? `${t(title)} ${slug}| Adheart - ad intelligence tool`
      : 'Adheart - ad intelligence tool'
  }, [title, t, slug])

  return (
    <Head>
      <title>{titleName}</title>
      <meta
        property="og:title"
        content={tCommon('metaTitle', { ...{ name: title ?? '' } })}
        key="title"
      />
      <meta name="description" content={descriptionTranslate} />
      <meta property="og:description" content={descriptionTranslate} />
    </Head>
  )
}

export default BaseHead
